import { c as _c } from "react/compiler-runtime";
import { useAppSelector } from "@store/store-helper";
import { selectIElementWorldMatrix } from "@faro-lotv/project-source";
import { getMarkupMeasurements } from "@utils/markups-utils";
import { Stack } from "@mui-wrapper";
import { LengthIcon, PerimeterIcon, Area2Icon, DistanceHorizontalIcon, DistanceVerticalIcon, Text } from "@flat-ui";
import { MarkupMeasurement } from "@pages/project-details/project-markups/sidepanel/markup-measurement";
import { MarkupSidePanelSection } from "@pages/project-details/project-markups/sidepanel/markup-sidepanel-section";
/**
 * Renders different measurement values of a measure polygon element associated to an annotation
 */
export function MarkupMeasurements(t0) {
  const $ = _c(51);
  const {
    measurePolygon,
    unitMeasurement
  } = t0;
  let t1;
  if ($[0] !== measurePolygon.id) {
    t1 = selectIElementWorldMatrix(measurePolygon.id);
    $[0] = measurePolygon.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const worldMatrix4Tuple = useAppSelector(t1);
  let t2;
  if ($[2] !== measurePolygon || $[3] !== unitMeasurement || $[4] !== worldMatrix4Tuple) {
    t2 = getMarkupMeasurements({
      measurePolygon,
      worldMatrix4Tuple,
      unitMeasurement
    });
    $[2] = measurePolygon;
    $[3] = unitMeasurement;
    $[4] = worldMatrix4Tuple;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    isClosed,
    length,
    area,
    horizontal,
    vertical
  } = t2;
  let T0;
  let T1;
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== area || $[7] !== horizontal || $[8] !== isClosed || $[9] !== length || $[10] !== measurePolygon || $[11] !== unitMeasurement || $[12] !== vertical || $[13] !== worldMatrix4Tuple) {
    const segmentEnds = isClosed && measurePolygon.points.length > 2 ? [...measurePolygon.points, measurePolygon.points[0]] : measurePolygon.points;
    const segmentLengths = measurePolygon.points.length > 2 ? segmentEnds.slice(1).map((end, index) => getMarkupMeasurements({
      measurePolygon: {
        ...measurePolygon,
        isClosed: false,
        points: [segmentEnds[index], end]
      },
      worldMatrix4Tuple,
      unitMeasurement
    }).length) : [];
    const lengthTooltip = isClosed ? "Perimeter" : "Length";
    T1 = MarkupSidePanelSection;
    t9 = "Measurement values";
    t10 = "measurementValues";
    T0 = Stack;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        gap: 1
      };
      $[24] = t3;
    } else {
      t3 = $[24];
    }
    if ($[25] !== area) {
      t4 = area && <MarkupMeasurement value={area} tooltip="Area" icon={<Area2Icon />} />;
      $[25] = area;
      $[26] = t4;
    } else {
      t4 = $[26];
    }
    const t11 = segmentLengths.length > 0 ? "Total" : undefined;
    const t12 = segmentLengths.length > 0 ? "Total length" : lengthTooltip;
    let t13;
    if ($[27] !== isClosed) {
      t13 = isClosed ? <PerimeterIcon /> : <LengthIcon />;
      $[27] = isClosed;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    if ($[29] !== length || $[30] !== t11 || $[31] !== t12 || $[32] !== t13) {
      t5 = <MarkupMeasurement value={length} label={t11} tooltip={t12} icon={t13} />;
      $[29] = length;
      $[30] = t11;
      $[31] = t12;
      $[32] = t13;
      $[33] = t5;
    } else {
      t5 = $[33];
    }
    if ($[34] !== horizontal) {
      t6 = horizontal && <MarkupMeasurement value={horizontal} tooltip="Horizontal" icon={<DistanceHorizontalIcon />} />;
      $[34] = horizontal;
      $[35] = t6;
    } else {
      t6 = $[35];
    }
    if ($[36] !== vertical) {
      t7 = vertical && <MarkupMeasurement value={vertical} tooltip="Vertical" icon={<DistanceVerticalIcon />} />;
      $[36] = vertical;
      $[37] = t7;
    } else {
      t7 = $[37];
    }
    t8 = segmentLengths.length > 0 && <Stack sx={{
      gap: 1
    }} data-testid="markup-measurement-segments">{segmentLengths.map(_temp)}</Stack>;
    $[6] = area;
    $[7] = horizontal;
    $[8] = isClosed;
    $[9] = length;
    $[10] = measurePolygon;
    $[11] = unitMeasurement;
    $[12] = vertical;
    $[13] = worldMatrix4Tuple;
    $[14] = T0;
    $[15] = T1;
    $[16] = t10;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    T0 = $[14];
    T1 = $[15];
    t10 = $[16];
    t3 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  let t11;
  if ($[38] !== T0 || $[39] !== t3 || $[40] !== t4 || $[41] !== t5 || $[42] !== t6 || $[43] !== t7 || $[44] !== t8) {
    t11 = <T0 sx={t3}>{t4}{t5}{t6}{t7}{t8}</T0>;
    $[38] = T0;
    $[39] = t3;
    $[40] = t4;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
    $[44] = t8;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] !== T1 || $[47] !== t10 || $[48] !== t11 || $[49] !== t9) {
    t12 = <T1 title={t9} trackingName={t10}>{t11}</T1>;
    $[46] = T1;
    $[47] = t10;
    $[48] = t11;
    $[49] = t9;
    $[50] = t12;
  } else {
    t12 = $[50];
  }
  return t12;
}
function _temp(value, index_0) {
  return <Stack key={index_0} direction="row" sx={{
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1
  }}><Text variant="bodyS">Segment <var>{index_0 + 1}</var></Text><MarkupMeasurement value={value} tooltip="Length" icon={<LengthIcon />} /></Stack>;
}